import React from 'react'
import { Box, Link, Stack } from '~/design_system'
import { Msg } from '~/common/localizationUtils'
import { WorkdayVndlyLogoLink } from '../WorkdayVndlyLogo'

/*
It is expected that the Footer component is inside the design system's Container component this will avoid issues
with the Contact Us sidebar button
 */

export const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <Box mt={12} mb={10}>
      <Stack as="footer" spacing={{ base: 4, md: 1 }} alignItems="center" textStyle="bodySmall">
        <WorkdayVndlyLogoLink width="200" />
        <Box textAlign="center">
          <Link variant="link" size="sm" href="https://www.workday.com/en-us/privacy.html" target="_blank">
            <Msg id="footer.privacy" description="Privacy" />
          </Link>
          <Box as="span" ml={1}>
            <Msg
              id="footer.copyright"
              year={String(year)}
              description="© {year} Workday, Inc. All rights reserved. Proprietary and Confidential - For Authorized Use Only"
            />
          </Box>
        </Box>
        <Link variant="link" size="sm" href="/home/tnc" target="_blank">
          <Msg id="footer.workday_vndly_terms_of_use" description="Workday VNDLY - Terms of Use" />
        </Link>
      </Stack>
    </Box>
  )
}
